// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'

// 获取部门列表
export function getList(data) {
  const url = global.requestUrl + '/department/list?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 创建部门信息
export function createOne(data) {
  const url = global.requestUrl + '/department/create'
  return axios.post(url, data)
}

// 更新部门信息
export function updateOne(data) {
  const url = global.requestUrl + '/department/update'
  return axios.post(url, data)
}

// 删除部门信息
export function deleteOne(data) {
  const url = global.requestUrl + '/department/delete/' + data.id
  return axios.get(url)
}
